import { isPositiveNumber } from "et3-type-guards";
import i18n from "../constants/i18n";
import { TUserMessagesDataCounts } from "../Types";
import ET3Div from "../core/et3-div";
import { withLiteObserverAndTheme } from "../core/et3-enhanced-render";
import Et3Text from "../core/et3-text";
import Et3Margin from "../core/et3-ui/ET3Margin";

const SocialMediaBadWordsCounter = withLiteObserverAndTheme<{
  socialMediaBadWordsCount: TUserMessagesDataCounts;
}>((props) => {
  const { theme, socialMediaBadWordsCount } = props;
  const { colors, unitX } = theme;

  return isPositiveNumber(socialMediaBadWordsCount[0].messagesCount) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1520}
      height={100}
      fDirection="row"
      alignItems="flex-end"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      {socialMediaBadWordsCount.map((wordsObject) => {
        const tagColor =
          wordsObject.text === i18n.get("SOCIAL_MEDIA_ACCOUNT")
            ? colors.all.orange
            : colors.all.red;
        return isPositiveNumber(wordsObject.messagesCount) ? (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={380}
            height={30}
            fDirection="row"
            alignItems="center"
            justifyContent="center"
            color={colors.all.transparent}
            style={{
              color: tagColor
            }}
            onClick={() => {}}
          >
            <Et3Text
              fontFamily={"BOLD"}
              fontSize={28}
              text={`${wordsObject.text}`}
              isSpan={false}
              color={tagColor}
              style={{}}
            />
            <Et3Margin top={0} bottom={0} right={10} left={0} />
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={90}
              height={30}
              fDirection="row"
              alignItems="center"
              justifyContent="center"
              color={colors.all.transparent}
              style={{
                borderRadius: 20,
                padding: 5 * unitX,
                border: `2px solid ${tagColor}`
              }}
              onClick={() => {}}
            >
              <Et3Text
                fontFamily={"MEDIUM"}
                fontSize={24}
                text={`${wordsObject.count}/${wordsObject.messagesCount}`}
                isSpan={false}
                color={tagColor}
                style={{}}
              />
            </ET3Div>
          </ET3Div>
        ) : null;
      })}
    </ET3Div>
  ) : null;
});
export default SocialMediaBadWordsCounter;
